import { computed, ref } from 'vue'
import { type RingBuilder } from '@/composables/useRingBuilder.ts'
import StoneModal from '@/components/stone/search/sku/StoneModal.vue'
import GemstoneModal from '@/components/stone/search/nonsku/modal/GemstoneModal.vue'
import LabGrownDiamondModal from '@/components/stone/search/nonsku/modal/LabGrownDiamondModal.vue'
import { assertNever } from '@/helpers'

export function useEngagementRing3rdStepStoneModal(ringBuilder: RingBuilder) {
    const isOpen = ref(false)

    const open = () => {
        isOpen.value = true
    }
    const close = () => {
        isOpen.value = false
    }

    const component = computed(() => {
        const stone = ringBuilder.stone.value
        if (!stone) {
            return undefined
        }

        switch (stone.__typename) {
            case 'GemsApi_Stone':
                return {
                    is: StoneModal,
                    props: { stoneId: stone.identifier },
                    events: { close },
                }
            case 'NonSkuLabGrown':
                return {
                    is: LabGrownDiamondModal,
                    props: { stone },
                    events: { close },
                }
            case 'NonSkuGemstone':
                return {
                    is: GemstoneModal,
                    props: { stone },
                    events: { close },
                }
            default:
                return assertNever(stone, undefined)
        }
    })

    return {
        isOpen,
        open,
        component,
    }
}
